import React from 'react';
import classnames from 'classnames';
import { noop, isEmpty, get, defaultTo, isEqual, isUndefined } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { inputFieldCheckbox as InputFieldCheckbox } from 'ui/views/generic/inputFieldCheckbox';
 *
 * // render
 * <InputFieldCheckbox propName='propValue'/>
 */
export const inputFieldCheckbox = ( props ) => {

     // get error message (ref)
     const errorMessage = get( props.error, 'message', null );
     const hasError = !isEmpty( errorMessage );
 
     // dynamic class name
     const widgetClassName = classnames( 'ui-input-field-checkbox', props.className, {
         'ui-input-field-checkbox--error': hasError,
     } );
 
     const inputClassName = classnames( 'ui-input-field-checkbox__input__element', {
         'ui-input-field-checkbox__input__element--disabled': props.disabled || get( props, 'config.readonly', false ),
         'ui-input-field-checkbox__input--checked': defaultTo( props.value, undefined ),
     } );
 
     return (
        <div className={ widgetClassName }>
 
            {/* input */}
            <div className='ui-input-field-checkbox__input'>
 
                <input
                    type="checkbox"
                    id={ `${ props.name }__checkbox` }
                    className={ inputClassName }
                    checked={ defaultTo( props.value, undefined ) }
                    readOnly = { props.disabled || get( props, 'config.readonly', false ) }
                    onChange={ () => props.onChange( {
                        name: props.name,
                        value: isUndefined( props.value ) ? true : !props.value,
                    } ) }
                
                />
 
                {
                    props.showLabel ? (
                        <label className='ui-input-field-checkbox__label' for = { `${ props.name }__checkbox` }>
                            {/* label text */}
                            <div className='ui-input-field-checkbox__text'>{ getLabel( props.label ) }</div>
                        </label>
                    ) : null
                }
            </div>
 
            {/* error message */}
            {
                hasError && ! isEqual( props.mode, 'readonly' ) ? (
                    <div className='ui-input-field__error'>
                        <div className='ui-input-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
     );
};

// set display name
inputFieldCheckbox.displayName = 'inputFieldCheckbox';

// set default props
inputFieldCheckbox.defaultProps = {

    name: null,
    label: null,
    placeholder: null,
    disabled: false,
    value: '',
    onChange: noop,
    required: false,
    error: {},
    mode: null, // possible values `null`, `readonly`.
    mask: undefined,
    showLabel: true,
    prefix: null,
};

// prop types
inputFieldCheckbox.propTypes = {};
